import { createSlice } from '@reduxjs/toolkit';
import { portalApi } from '../api/portalApi';

// Re-export RTK Query hook for direct component use
export { useGetPumpDetailsQuery } from '../api/portalApi';

/**
 * Backward-compatible thunk wrapper.
 */
export const fetchPumpDetails = (projectID) => (dispatch) => {
  return dispatch(
    portalApi.endpoints.getPumpDetails.initiate(projectID ?? undefined, {
      forceRefetch: false,
    })
  );
};

const pumpDetailsSlice = createSlice({
  name: 'pumpDetails',
  initialState: {
    data: [],
    loading: false,
    error: null,
    lastFetch: null,
  },
  reducers: {
    clearPumpDetails: (state) => {
      state.data = [];
      state.loading = false;
      state.error = null;
      state.lastFetch = null;
    },
    setPumpDetails: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ── RTK Query: getPumpDetails ───────────────────────────────────────
      .addMatcher(
        portalApi.endpoints.getPumpDetails.matchPending,
        (state) => {
          state.loading = true;
          state.error = null;
        }
      )
      .addMatcher(
        portalApi.endpoints.getPumpDetails.matchFulfilled,
        (state, action) => {
          state.loading = false;
          state.data = action.payload;
          state.lastFetch = new Date().toISOString();
        }
      )
      .addMatcher(
        portalApi.endpoints.getPumpDetails.matchRejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error?.message ?? 'Failed to fetch pump details';
        }
      );
  },
});

export const { clearPumpDetails, setPumpDetails } = pumpDetailsSlice.actions;
export default pumpDetailsSlice.reducer;
